import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class WeightGridLine extends BasicEntity {
key: string;
weight: number | null;
weightGridCode: string;
weightGridId: number | null;
}

